import { Component, NgModule, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxSelectBoxModule } from 'devextreme-angular';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';

import { UserPanelModule } from '../user-panel/user-panel.component';
import { AuthService, DataService, IUser } from 'src/app/services';
import { ThemeSwitcherModule } from 'src/app/components/library/theme-switcher/theme-switcher.component';
import { Router } from '@angular/router';

@Component({
	selector: 'app-header',
	templateUrl: 'app-header.component.html',
	styleUrls: ['./app-header.component.scss'],
})

export class AppHeaderComponent implements OnInit {
	@Output()
	menuToggle = new EventEmitter<boolean>();

	@Input()
	menuToggleEnabled = false;

	@Input()
	title!: string;

	private _user: IUser | null = null;

	userMenuItems = [
		{
			text: 'Jelszó módosítás',
			icon: 'lock',
			onClick: () => {
				this._router.navigate([`/auth/change-password`]);
				console.log("change password");
			},
		},
		{
			text: 'Kijelentkezés',
			icon: 'runner',
			onClick: () => {
				this._authService.logOut();
			},
		}
	];

	private _authService: AuthService;
	private _dataService: DataService;
	private _router: Router;
	private _tenant: any;
	private _tenants: any[];

	public get user(): IUser | null { return this._user; }
	public get tenants(): any[] { return this._tenants; }
	public get tenantId(): number { return this._tenant?.id; }
	public get tenantName(): string { return this._tenant?.name; }

	constructor(authService: AuthService, 
		dataService: DataService,
		router: Router
	) { 
		this._authService = authService;
		this._dataService = dataService;
		this._router = router;
		this._tenant = null;
		this._tenants = [];
	}

	ngOnInit() {
		this._authService.getUser().then((e) => {
			this._user = e.data;

			this._dataService.getLookUpUserTenants().subscribe({
				next: (response) => {
					this._tenants = response;
					this._tenant = this._tenants[0];
				}
			});
		});
	}

	toggleMenu = () => {
		this.menuToggle.emit();
	};

	public handleTenantSelect($event) {
		this._tenant = this._tenants.find(t => t.id === $event.value);
		this._dataService.selectTenant($event.value);
		this._dataService.tenantId = $event.value;
		this._router.navigate([`/work-request-list`]);
	}
}

@NgModule({
	imports: [
		CommonModule,
		DxButtonModule,
		DxToolbarModule,
		DxSelectBoxModule,
		ThemeSwitcherModule,
		UserPanelModule,
	],
	declarations: [AppHeaderComponent],
	exports: [AppHeaderComponent],
})
export class AppHeaderModule { }
